var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options)?_c('div',{staticClass:"article_vertical_head"},[_c('div',{staticClass:"article_vertical_head__vertical_corner"},[_c('span',{staticClass:"article_vertical_head__vertical_corner__text",class:[ 
                _vm.options.position],domProps:{"innerHTML":_vm._s(_vm.options.text)}}),_c('img',{staticClass:"article_vertical_head__vertical_corner__image_border",attrs:{"src":require("@/assets/images/commons/article-vertical-head.png")}})]),_c('div',{staticClass:"article_vertical_head__author_image"},[_c('image-with-descriptions',{attrs:{"options":{
                    image : _vm.options.imageAuthor,
                    descriptions: [
                            {
                                text: "&copy;EDF",
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'vertical' // vertical, horizontal
                            } ]
                }}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }